import React, { useRef, useLayoutEffect } from "react";
import { connect } from "react-redux";
import styles from "../../../../add-edit-product/add-edit-product.scss";
import FormElement from '../../../FormElement';
import { updateBrandManufactureDetails } from '../../../../../actions/productSpecification';

import UOMSliderWrapper from '../../../UOMSliderWrapper';

function ContentUnitPerPiece(props){

	const uomSliderRef = useRef(null);

	function iOS() {
		let isIos = [
		  'iPad Simulator',
		  'iPhone Simulator',
		  'iPod Simulator',
		  'iPad',
		  'iPhone',
		  'iPod'
		].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes("Mac") && "ontouchend" in document);
		console.log('isIphone ',isIos);
		return isIos;
	  }

	useLayoutEffect(() => {
		if(
			Object.keys(props.contentWeightUnitSaved).length && 
			props.contentWeightUnitSaved.contentPerPiece.value.length && 
			props.contentWeightUnitSaved.unitPerPiece.value.length
		){
			props.updateBrandManufactureDetails({contentWeightUnit: props.contentWeightUnitSaved})
		}
	},[])

	const formElements = [{
		holderClass: styles['more-detail-grp'] + ' ' + styles.marginT20 + ' ' + styles['unit-holder'],
		formElements: [{
			label: 'Net Weight/Content',
			key: 'contentPerPiece',
			input: {
				value: props.contentPerPiece.value.toString() || '',
				type: !(props.isIPhone || iOS()) ? 'text' : 'tel',
				onChange: e => { 
					if(e.target.value.match(/^[+]?\d*\.?\d*$/ig)){
						props.handleChange(e, 'contentPerPiece');
					}
				},
				min: 0
			},
			hide: !!props.hideUOMSection,
			ignoreParentClass: true,
		},
		{
			label: 'Select Unit',
			key: 'unitPerPiece',
			showArrow: true,
			disableMovingLabel: true,
			dontMoveLabel: true,
			input: {
				value: (props.unitPerPiece.value.toString() || ''),
				onChange: e => props.handleChange(e, 'unitPerPiece'),
				readOnly: true,
				onClick: () => {
					uomSliderRef.current.openCloseUOMSlider(true);
				}
			},
			hide: !!props.hideUOMSection,
			ignoreParentClass: true,
		}]
	}]; 

	return (<>
		<FormElement
			formElements={formElements}
			errors={{
				contentPerPiece: props.contentPerPiece.error,
				unitPerPiece: props.unitPerPiece.error
			}}
		/>
		<UOMSliderWrapper
			ref={uomSliderRef}
			uomType='netweightUOM'
			isAddProduct={props.isAddProduct}
			onSelectUOM={(e,data) => props.handleChange(e,'unitPerPiece',data)}
		/>
		</>
	)
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        contentPerPiece: state.brandManufacturer.contentWeightUnit.contentPerPiece,
        unitPerPiece: state.brandManufacturer.contentWeightUnit.unitPerPiece,
		contentWeightUnitSaved: state.brandManufacturer.contentWeightUnitSaved,
		isIPhone: state.library.deviceData.isIphone
    }
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateBrandManufactureDetails: (payload) => dispatch(updateBrandManufactureDetails(payload))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ContentUnitPerPiece)